import { FunctionComponent, useCallback, useContext, useState } from 'react';
import { Button, ButtonAppearance } from '@atlassian/learning-components';
import { css } from '@compiled/react';
import { UserContext } from 'context/UserContext';
// import { getAnalyticsAnonymousId } from 'utils/utilities';

const Newsletter: FunctionComponent = () => {
  const data = useContext(UserContext);
  const user = data?.user;
  const [submitSuccess] = useState(false);

  const handleSignup = useCallback(async () => {
    // try {
    //   let formValues: NewsletterFormValues = {
    //     email: user?.email || '',    // TODO: Validate + replace with email entered in by user, which could be different from `user.email`
    //     anonymousId: getAnalyticsAnonymousId(),
    //   }
    //   if (user?.account_id) {
    //     formValues.atlassianId = user.account_id;
    //   }
    //   await handleNewsletterSignup(formValues);
    //   setSubmitSuccess(true);
    // } catch (error) {
    //   console.error('Error during newsletter signup:', error);
    //   // show error message / state
    // }
  }, [user]);

  return (
    <div css={containerStyle}>
      <h1>C&L Newsletter</h1>
      <br />
      <div>
        This is a test component to test subscribing the current user to the C&L
        newsletter. Please replace with actual implementation.
      </div>
      <br />
      {!submitSuccess ? (
        <Button
          label={'Subscribe'}
          appearance={ButtonAppearance.PRIMARY}
          onClick={handleSignup}
        />
      ) : (
        <div>
          <h2>✅ Success!</h2>
          <p>
            You have successfully subscribed to the C&L newsletter. Thank you!
          </p>
        </div>
      )}
    </div>
  );
};

export default Newsletter;

const containerStyle = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
});
